export class BusinessFrontPageClaims {
    public claim?: string;
    public subclaim?: string;

    constructor(json?: any) {
        if (!json) {
            return;
        }

        Object.assign(this, json);
    }
}
